import React, { useRef, useState } from "react";
import { NavLink } from "react-router-dom";
import ChevronDown from "../../../components/icons/ChevronDown";
import ChevronUp from "../../../components/icons/ChevronUp";
import { ExternalLink } from "../../../components";

export default function ListItem(props) {
  const { name, children, chevron, href, external, open, onClick, icon: Icon, count } = props;

  const [isOpen, setIsOpen] = useState(open);
  const contentRef = useRef(null);

  const handleToggle = (e) => {
    e.preventDefault();
    setIsOpen(!isOpen);
  };

  return children && children.length > 0 ? (
    <>
      <div
        className="group w-full flex items-center px-3 py-2 font-medium text-sm text-titleColor rounded-[8px] hover:text-gray-900 hover:bg-greyHover"
        onClick={handleToggle}>
        {Icon && <Icon className="mr-3" aria-hidden="true" />}
        <button className="flex items-center justify-between w-full pl-2">
          <span className="text-blueGreen">{name}</span>
          {chevron && <>{isOpen ? <ChevronUp /> : <ChevronDown />}</>}
        </button>
      </div>
      <div
        ref={contentRef}
        className="transition-all duration-300 ease-in-out ml-5 flex flex-col gap-1"
        style={{
          maxHeight: isOpen ? `${contentRef.current?.scrollHeight}px` : "0",
          opacity: isOpen ? 1 : 0,
          visibility: isOpen ? "visible" : "hidden",
        }}>
        {children.map((item, index) => (
          <ListItem key={index} {...item} />
        ))}
      </div>
    </>
  ) : (
    <>
      {external ? (
        <ExternalLink
          href={href}
          className="group w-full flex items-center px-3 py-2 font-medium text-sm text-titleColor rounded-[8px] hover:text-gray-900 hover:bg-greyHover">
          {name}
        </ExternalLink>
      ) : (
        <NavLink
          to={href}
          onClick={onClick}
          className={({ isActive }) =>
            isActive
              ? "group w-full flex items-center bg-greyHover px-3 py-2 font-medium text-sm text-titleColor rounded-[8px] hover:text-gray-900"
              : "group w-full flex items-center px-3 py-2 font-medium text-sm text-titleColor rounded-[8px] hover:text-gray-900 hover:bg-greyHover"
          }>
          <span>{name}</span>
          {count > 0 && (
            <span className="ml-2 rounded-[50px] text-[11px] bg-[#EF4444] text-white flex items-center justify-center w-[20px] h-[20px]">
              {count}
            </span>
          )}
        </NavLink>
      )}
    </>
  );
}
